var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({},'v-select',_vm.defaultConfigs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }